import { useEffect, useState } from "react";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Nav = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 500);
    return () => clearTimeout(t);
  }, []);
  return (
    <nav className={`nav-pill ${visible ? "visible" : ""}`} data-testid="floating-nav">
      <button
        className="nav-logo-btn"
        data-testid="nav-logo"
        onClick={() => {
          if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.2 });
          else window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      >
        <img src="/nexa-logo.png" alt="Nexa Lending" />
      </button>
      <button className="nav-link" data-testid="nav-learn-link" onClick={() => scrollTo("learn")}>LEARN</button>
      <button className="nav-link" data-testid="nav-host-link" onClick={() => scrollTo("host")}>HOST</button>
      <button className="nav-link" data-testid="nav-faq-link" onClick={() => scrollTo("faq")}>FAQ</button>
      <button className="nav-cta" data-testid="nav-register-cta" onClick={() => scrollTo("register")}>REGISTER ↗</button>
    </nav>
  );
};
